import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentStep: 1,
    totalSteps: 14, // Adjust if you add/remove steps
    formData: {
        signupFor: '',
        firstName: '',
        experiences: '',
        callFrequency: '',
        dateOfBirth: '',
        gender: '',
        profilePreview: null,
        scheduleDate: '',
        phoneNumber: '',
        countryCode: '',
        scheduleList: [], // Always an array
        requestCallId: ''
        // Add more fields as needed for your flow
    },
    signUpData: {
        fullName: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        countryCode: '',
        email: ''
    },
    // Global error/validation state
    error: null,
    validation: null,
};

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        nextStep: (state) => {
            if (state.currentStep < state.totalSteps) {
                state.currentStep += 1;
            }
        },
        prevStep: (state) => {
            if (state.currentStep > 1) {
                state.currentStep -= 1;
            }
        },
        updateFormData: (state, action) => {
            // Ensure scheduleList is always an array
            if (action.payload.scheduleList && !Array.isArray(action.payload.scheduleList)) {
                state.formData.scheduleList = Array.isArray(action.payload.scheduleList)
                    ? action.payload.scheduleList
                    : [action.payload.scheduleList];
            }
            state.formData = { ...state.formData, ...action.payload };
        },
        updateSignUpData: (state, action) => {
            state.signUpData = { ...state.signUpData, ...action.payload };
        },
        resetForm: (state) => {
            state.currentStep = 1;
            state.formData = initialState.formData;
            state.signUpData = initialState.signUpData;
            state.error = null;
            state.validation = null;
        },
        setStep: (state, action) => {
            const step = action.payload;
            if (step >= 1 && step <= state.totalSteps) {
                state.currentStep = step;
            }
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setValidation: (state, action) => {
            state.validation = action.payload;
        },
    },
});

export const { nextStep, prevStep, updateFormData, updateSignUpData, resetForm, setStep, setError, setValidation } = formSlice.actions;
export default formSlice.reducer; 